/** @jsx jsx */
import {graphql, useStaticQuery} from "gatsby"
import Img from "gatsby-image"
import {jsx} from "theme-ui"

export default function DesktopScreenshot(){
    const data = useStaticQuery(graphql`
        query {
            file(sourceInstanceName: {eq: "screenshots"}, name: {eq: "desktop"}) {
                childImageSharp {
                 fluid(quality:100) {
                    ...GatsbyImageSharpFluid_withWebp
                 }
                }
            }
        }      
    `)
    const imageData = data.file.childImageSharp.fluid

    return(
        <div sx={{
            borderRadius: 1,
            overflow: 'hidden',
            boxShadow: '0px 16px 48px rgba(0, 0, 0, 0.08)',
            width: '89%',
        }}>
            <Img fluid={imageData} alt="Desktop Screenshot" />
        </div>
    )
}